import { render, staticRenderFns } from "./ChatbotTriagem.vue?vue&type=template&id=1c082612&scoped=true&"
import script from "./ChatbotTriagem.vue?vue&type=script&lang=js&"
export * from "./ChatbotTriagem.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotTriagem.vue?vue&type=style&index=0&id=1c082612&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c082612",
  null
  
)

export default component.exports